import { Header, Icon } from "@caint/design-system";
import { Fragment } from "react";

export interface PlaceholderProps {
  title: string;
  onBack?: () => void;
}

/** Tela ainda não portada (chega no M6). Mantém a navegação funcional. */
export function Placeholder({ title, onBack }: PlaceholderProps) {
  return (
    <Fragment>
      <Header title={title} onBack={onBack} />
      <div className="m-body" style={{ display: "grid", placeItems: "center", textAlign: "center" }}>
        <div style={{ maxWidth: 280, color: "var(--text-muted)" }}>
          <div style={{ display: "grid", placeItems: "center", marginBottom: 14, color: "var(--slate-300)" }}>
            <Icon name="layers" size={44} stroke={1.4} />
          </div>
          <div style={{ fontWeight: 700, color: "var(--text)", marginBottom: 6 }}>Em construção</div>
          <p style={{ fontSize: 14, lineHeight: 1.5 }}>
            Esta tela será portada na próxima etapa. O núcleo de campo (Início e Checklist) já está funcional,
            com recálculo de IMGQ ao vivo.
          </p>
        </div>
      </div>
    </Fragment>
  );
}
